<template>
  <div>
    <div class="Kanit">
      <div class="text-center mt-8">
        <img height="100px" src="@/assets/logo.png" />
      </div>
      <ValidationObserver ref="observer">
        <div class="px-5">
          <div
            class="mt-4 mb-6 primary--text text-center"
            style="font-weight: 600; font-size: 20px"
          >
            กรุณากำหนดรหัสผ่านใหม่
          </div>
          <ValidationProvider
            vid="main_password"
            name="รหัสผ่าน"
            rules="required|passwordLength"
            v-slot="{ errors }"
          >
            <custom-input
              :type="'password'"
              v-model="input.password"
              :label="'รหัสผ่าน'"
              outlined
              :error-messages="errors"
            >
            </custom-input>
          </ValidationProvider>
          <ValidationProvider
            name="ยืนยันรหัสผ่าน"
            rules="required|confirmed:main_password"
            v-slot="{ errors }"
          >
            <custom-input
              :type="'password'"
              v-model="input.confirm_password"
              :label="'ยืนยันรหัสผ่าน'"
              outlined
              :error-messages="errors"
            >
            </custom-input>
          </ValidationProvider>
        </div>
        <div class="text-center">
          <v-btn @click="next" :loading="saveloading" large color="primary"
            >ยืนยัน</v-btn
          >
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import CustomInput from "../../components/CustomInput.vue";
import axios from "axios";
export default {
  components: { CustomInput },
  data() {
    return {
      input: {
        password: "",
        confirm_password: "",
      },
      saveloading: false,
    };
  },
  computed: {},
  created() {
    this.$store.state.headertext = "";
  },
  methods: {
    async next() {
      if (await this.$refs.observer.validate()) {
        this.saveloading = true;
        var data = {
          userid: this.userid,
          pageid: this.query.pageid,
          memberId: this.query.memberId, // จะส่งมาใน URL
          password: this.input.password,
        };
        axios
          .put(this.serverUrl + "yasale/reset-password", data, {
            headers: { AUTHORIZATION: "Bearer xxxx xxxx" },
          })
          .then(async (response) => {
            this.saveloading = false;
            if (response.data.responsecode == 200) {
              this.$emit("nextstep");
            } else {
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>